import React from "react";
import { Button, Paper, Typography } from "@material-ui/core";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Mantem o erro visivel no console sem derrubar a interface inteira.
    console.error("Erro de renderização capturado:", error, info);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 24,
          background: "#f4f6f8"
        }}
      >
        <Paper
          variant="outlined"
          style={{
            maxWidth: 460,
            padding: 24,
            borderRadius: 6
          }}
        >
          <Typography variant="h6" gutterBottom>
            Não foi possível carregar esta tela
          </Typography>
          <Typography color="textSecondary" paragraph>
            Atualize a página para tentar novamente. Se continuar acontecendo,
            teste sem extensões do navegador.
          </Typography>
          <Button color="primary" variant="contained" onClick={this.handleReload}>
            Recarregar
          </Button>
        </Paper>
      </div>
    );
  }
}

export default ErrorBoundary;
